import { useQuery } from "@tanstack/react-query";

import { fetchAnnouncement } from "@/api/system";

export const SYSTEM_ANNOUNCEMENTS_QUERY_KEY = ["system-announcement"];

export function normalizeCurrentAnnouncements(response) {
  const items = Array.isArray(response?.announcements)
    ? response.announcements
    : response?.announcement
      ? [response.announcement]
      : [];

  return [...items]
    .sort((a, b) => Number(a?.sortIndex ?? 0) - Number(b?.sortIndex ?? 0))
    .filter((announcement) => {
      const message = String(announcement?.message || "").trim();
      if (!announcement?.active || !message) return false;

      if (announcement?.expiresAt) {
        const expiresAt = new Date(announcement.expiresAt);
        if (!Number.isNaN(expiresAt.getTime()) && expiresAt.getTime() <= Date.now()) {
          return false;
        }
      }

      return true;
    });
}

export function useSystemAnnouncements(options = {}) {
  const query = useQuery({
    queryKey: SYSTEM_ANNOUNCEMENTS_QUERY_KEY,
    queryFn: fetchAnnouncement,
    staleTime: 5 * 60_000,
    gcTime: 60 * 60_000,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    ...options,
  });

  return {
    ...query,
    announcements: normalizeCurrentAnnouncements(query.data),
  };
}
